import React from 'react';
import { ExactOnlineProviders } from './exactOnline/ExactOnlineProviders';
import { InvoiceForwardingProviders } from './invoiceForwarding/InvoiceForwardingProviders';
import { RosaProviders } from './rosa/RosaProviders';
import { ExactGlobeProviders } from './exactGlobe/ExactGlobePage';
import { PeppolProviders } from './peppol/peppol.components';
import { CochlearProviders } from './cochlear/cochlear.components';

export const IntegrationsProviders = ({ children }: any) => {
	return (
		<RosaProviders>
			<ExactOnlineProviders>
				<InvoiceForwardingProviders>
					<PeppolProviders>
						<ExactGlobeProviders>
							<CochlearProviders>{children}</CochlearProviders>
						</ExactGlobeProviders>
					</PeppolProviders>
				</InvoiceForwardingProviders>
			</ExactOnlineProviders>
		</RosaProviders>
	);
};
